export default function Hanchor() {
  return (
    <div className="container d-flex justify-content-center align-items-center" style={{height:"100vh"}}>
       <h1 style={{fontSize:"2.5rem", color:"#3AB0FF"}}><span>Hanch</span><span style={{color:"#F39237"}}>o</span><span>r</span></h1>
    </div>
  )
}
